import { render } from "./Stats.vue?vue&type=template&id=a14c5b0a&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=a14c5b0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14c5b0a"]])

export default __exports__